import React from "react";
import "./ProcessSection.scss";

const ProcessSection = ({ processSection }) => {
    function importAll(r) {
        let images = {};
        r.keys().map((item) => {
            images[item.replace("./", "")] = r(item);
        });
        return images;
    }

    const logoFolderImages = importAll(
        require.context(
            `../../../../../../public/images/Process`,
            false,
            /\.(png|jpe?g|svg)$/
        )
    );

    return (
        <section className="process-section">
            <div className="container">
                <h2 className="section-heading">
                    Process We Follow For {processSection.title}
                </h2>

                <p className="section-subheading">
                    {processSection.description}
                </p>

                <div className="process-grid">
                    <div className="process-row first-row">
                        {processSection.steps.slice(0, 3).map((step, i) => (
                            <div className="process-step-card position-relative" key={step.number}>
                                <div className="step-header">
                                    <div className="step-number">{i + 1}</div>
                                    <div className="step-icon-wrapper">
                                        <img
                                            src={logoFolderImages[step.icon]}
                                            alt={step.title}
                                            className="step-icon"
                                        />
                                    </div>
                                    <h3 className="step-title">{step.title}</h3>
                                </div>
                                <div className="step-content">

                                    <p className="step-description">{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="process-row first-row">
                        {processSection.steps.slice(3, processSection.steps.length).map((step, i) => (
                            <div className="process-step-card" key={step.number}>
                                <div className="step-header">
                                    <div className="step-number">{i + 4}</div>
                                    <div className="step-icon-wrapper">
                                        <img
                                            src={logoFolderImages[step.icon]}
                                            alt={step.title}
                                            className="step-icon"
                                        />
                                    </div>
                                    <h3 className="step-title">{step.title}</h3>
                                </div>
                                <div className="step-content">
                                    <p className="step-description">{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;